(() => {
  'use strict';
  const script = document.currentScript;
  const manifestUrl = script?.dataset.manifest;
  const managed = new Set(['6624804896903', '7898797703303', '7932449718407', '7450460586119']);
  const states = new WeakMap();
  let manifest = null;
  let failed = false;

  // CSS keeps controls inserted later by Zepto/Perrsonalize covered without
  // changing their own inline visibility, disabled state, or artwork fields.
  const style = document.createElement('style');
  style.textContent = `
    product-info[data-customization-restricted] #craftmark-customize-btn,
    product-info[data-customization-restricted] #perrsonalize-root,
    product-info[data-customization-restricted] [id^="pplr-"],
    product-info[data-customization-restricted] form[action*="/cart/add"] [type="submit"],
    product-info[data-customization-restricted] form[action*="/cart/add"] button[name="add"],
    product-info[data-customization-restricted] .shopify-payment-button,
    product-info[data-customization-restricted] shopify-accelerated-checkout,
    .pplr-modal-box form[data-customization-restricted] [type="submit"],
    .pplr-modal-box form[data-customization-restricted] button[name="add"] {
      display: none !important;
    }
    .customization-availability-message {
      border: 1px solid #b78424; border-radius: .4rem; padding: 1rem;
      background: #fff9e9; color: #5b410e; line-height: 1.5;
    }
    .customization-availability-message[hidden] { display: none; }
  `;
  document.head.append(style);

  const blank = value => /^(blank no art|no top print|blank|none|no art)$/i.test(value.trim());
  function selected(root) {
    const input = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    const node = root.querySelector('variant-selects [data-selected-variant]');
    if (!input?.value || !node) return null;
    try {
      const variant = JSON.parse(node.textContent);
      return variant && String(variant.id) === String(input.value) ? variant : null;
    } catch { return null; }
  }
  function messageFor(productId, variant) {
    const options = variant?.options || [];
    if (productId === '7932449718407') {
      return 'Base printing is temporarily unavailable in Sky Blue. Choose another color, or choose Blank No Art for the base.';
    }
    if (productId === '6624804896903' && ['Charcoal', 'Latte Brown', 'Ivory White'].includes(options[0]) && options.some(value => /^three sides$/i.test(value))) {
      return 'Three Sides printing is temporarily unavailable. Choose Single Sided, Two Sides, Four Sides, or Blank No Art for the base.';
    }
    return 'Printing is temporarily unavailable for this color. Choose Charcoal, Latte Brown, or Ivory White, or choose blank artwork for both top and base.';
  }
  function refreshRoot(root) {
    const productId = String(root.dataset.productId || '');
    if (!managed.has(productId)) return;
    let state = states.get(root);
    if (!state) {
      const warning = document.createElement('p');
      warning.className = 'customization-availability-message';
      warning.setAttribute('role', 'status');
      warning.setAttribute('aria-live', 'polite');
      const entry = root.querySelector('#craftmark-customize-btn, [id^="pplr-"], #perrsonalize-root, product-form');
      if (entry) entry.before(warning); else root.append(warning);
      state = { warning, signature: null, restricted: true };
      states.set(root, state);
    }
    if (!state.warning.isConnected) {
      const entry = root.querySelector('#craftmark-customize-btn, [id^="pplr-"], #perrsonalize-root, product-form');
      if (entry) entry.before(state.warning); else root.append(state.warning);
    }
    const variant = selected(root);
    const signature = JSON.stringify([variant?.id, variant?.options, !!manifest, failed]);
    if (signature === state.signature && state.warning.isConnected) return;
    state.signature = signature;
    const product = manifest?.products[productId];
    const printing = variant?.options?.slice(1) || [];
    // Blank products need no artwork service. Keep them purchasable even if
    // the availability file cannot load, retaining native inventory controls.
    const isBlank = printing.length > 0 && printing.every(blank);
    const allowed = !!variant && (isBlank || product?.allowed.has(String(variant.id)));
    state.restricted = !allowed;
    root.toggleAttribute('data-customization-restricted', !allowed);
    state.warning.hidden = allowed;
    if (!allowed) {
      state.warning.textContent = !variant ? 'Checking your selected options…'
        : failed ? 'Customization availability could not be checked. Please reload this page to retry.'
        : !manifest ? 'Checking customization availability…' : messageFor(productId, variant);
    }
  }
  function refresh() {
    document.querySelectorAll('product-info').forEach(refreshRoot);
    document.querySelectorAll('.pplr-modal-box form').forEach(refreshPopup);
  }
  function refreshPopup(form) {
    if (!cartAddForm(form) || ![...document.querySelectorAll('product-info')].some(root => managed.has(String(root.dataset.productId)))) return false;
    // Zepto moves its cart form under body. Judge that form's actual variant,
    // retaining an existing supported editor even if the page selection changed.
    const id = form.querySelector('input[name="id"]')?.value;
    const product = Object.values(manifest?.products || {}).find(p => p.allowed.has(String(id)) || p.restricted.has(String(id)));
    const restricted = !product || product.restricted.has(String(id));
    form.toggleAttribute('data-customization-restricted', restricted);
    let warning = form.querySelector('.customization-availability-message');
    if (!warning) {
      warning = document.createElement('p');
      warning.className = 'customization-availability-message';
      warning.setAttribute('role', 'status');
      warning.setAttribute('aria-live', 'polite');
      form.prepend(warning);
    }
    warning.hidden = !restricted;
    if (restricted) warning.textContent = failed ? 'Customization availability could not be checked. Please reload this page to retry.'
      : !manifest ? 'Checking customization availability…'
      : 'Printing is temporarily unavailable for the selected options. Close this editor and choose another color or blank artwork.';
    return restricted;
  }
  function restrictedTarget(target) {
    const popupForm = target instanceof Element ? target.closest('.pplr-modal-box form') : null;
    if (popupForm) return refreshPopup(popupForm);
    const root = target instanceof Element ? target.closest('product-info') : null;
    if (!root || !managed.has(String(root.dataset.productId))) return false;
    refreshRoot(root);
    return root.hasAttribute('data-customization-restricted');
  }
  function cartAddForm(form) {
    return form instanceof HTMLFormElement && /\/cart\/add(?:\.js)?\/?$/.test(new URL(form.action, location.href).pathname);
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!cartAddForm(form)) return;
    if (restrictedTarget(form)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', event => {
    const entry = event.target instanceof Element ? event.target.closest('#craftmark-customize-btn, [id^="pplr-"], #perrsonalize-root, .shopify-payment-button, shopify-accelerated-checkout, button[name="add"], [type="submit"]') : null;
    if (entry?.matches('button[name="add"], [type="submit"]') &&
      !entry.matches('#craftmark-customize-btn, [id^="pplr-"], #perrsonalize-root, .shopify-payment-button, shopify-accelerated-checkout') &&
      !cartAddForm(entry.form || entry.closest('form'))) return;
    if (entry && restrictedTarget(entry)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('change', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', refresh);
  setInterval(refresh, 200);
  refresh();

  if (!manifestUrl) { failed = true; refresh(); return; }
  fetch(manifestUrl, { signal: AbortSignal.timeout(10000) }).then(async response => {
    if (!response.ok) throw new Error('Availability file unavailable');
    const data = await response.json();
    if (data.version !== 1 || !data.products || [...managed].some(id => !Array.isArray(data.products[id]?.allowedVariantIds) || !Array.isArray(data.products[id]?.restrictedVariantIds))) {
      throw new Error('Invalid availability file');
    }
    for (const product of Object.values(data.products)) {
      product.allowed = new Set(product.allowedVariantIds.map(String));
      product.restricted = new Set(product.restrictedVariantIds.map(String));
    }
    manifest = data;
  }).catch(() => { failed = true; }).finally(refresh);
})();
